<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>
            <Header></Header>

            <section class="content create-due-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-11 form-request-content-large">
                            <div class="request-title">
                                <h1>DUE : Créer</h1>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                          <ul class="breadcrumb-steps">
                            <li class="breadcrumb-steps__item active">
                              <span class="breadcrumb-steps__num">1</span>
                              <span class="breadcrumb-steps__descr">
                                Création du modèle de DUE
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">2</span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des bénéficiaires
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item">
                              <span class="breadcrumb-steps__num">3</span>
                              <span class="breadcrumb-steps__descr">
                                Paramétrage des cotisations
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">4</span>
                              <span class="breadcrumb-steps__descr">
                                Délais applicables
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">5</span>
                              <span class="breadcrumb-steps__descr">
                                Cas de dispense facultatifs
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">6</span>
                              <span class="breadcrumb-steps__descr">
                                Documents annexes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">7</span>
                              <span class="breadcrumb-steps__descr">
                                Informations importantes
                              </span>
                            </li>
                            <li class="breadcrumb-steps__item mobile-hide">
                              <span class="breadcrumb-steps__num">8</span>
                              <span class="breadcrumb-steps__descr">
                                Signature éléctronique
                              </span>
                            </li>
                          </ul>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                        name="exemption"
                                        method="post"
                                        enctype="multipart/form-data"
                                        novalidate="novalidate"
                                        class="needs-validation"
                                >
                                    <!-- Raison sociale -->
                                    <label class="required-field-asterisks required"
                                            for="company-name"
                                    >Raison sociale</label>
                                    <input type="text"
                                           id="company-name"
                                           class="form-control form-control-lg"
                                           placeholder="Raison sociale"
                                           :class="{ 'is-invalid': $v.formData.companyName.$error }"
                                           @input="delayTouch($v.formData.companyName)"
                                           v-model="formData.companyName"
                                    >
                                    <FormError error="La raison sociale est un champ obligatoire. Veuillez le renseigner."
                                               v-if="$v.formData.companyName.$error"
                                    ></FormError>
                                    <p v-if="this.legalInformation" class="input-legend">{{ legalInformation.companyName.legalAdvice }}</p>
                                    <!-- Raison sociale -->

                                    <!-- Is optional contract available -->
                                    <div class="form-group">
                                        <label class="required-field-asterisks"
                                               for="siren-or-siret"
                                        >SIREN ou SIRET</label>
                                        <select id="siren-or-siret"
                                                class="form-control select2"
                                                v-model="formData.isSiren"
                                        >
                                            <option :value="true">Siren</option>
                                            <option :value="false">Siret</option>
                                        </select>
                                    </div>

                                    <!-- SIREN -->
                                    <div v-if="true === formData.isSiren" class="form-group">
                                        <label class="required-field-asterisks required"
                                               for="siren"
                                        >SIREN</label>
                                        <masked-input id="siren"
                                                      type="text"
                                                      class="form-control form-control-lg"
                                                      placeholder="SIREN"
                                                      mask="111111111"
                                                      :class="{ 'is-invalid': $v.formData.siren.$error }"
                                                      @input="maskedDelayTouch($v.formData.siren)"
                                                      v-model="formData.siren"
                                        ></masked-input>
                                        <FormError error="Le numéro SIREN doit contenir 9 chiffres."
                                                   v-if="!$v.formData.siren.length && $v.formData.siren.$dirty"
                                        ></FormError>
                                        <FormError error="Le numéro SIREN est un champ obligatoire. Veuillez le renseigner."
                                                   v-if="!$v.formData.siren.required && $v.formData.siren.$dirty"
                                        ></FormError>
                                    </div>

                                    <!-- SIRET -->
                                    <div v-if="false === formData.isSiren"
                                         class="form-group"
                                    >
                                        <label class="required-field-asterisks required"
                                               for="siret"
                                        >SIRET</label>
                                        <masked-input id="siret"
                                                      type="text"
                                                      class="form-control form-control-lg"
                                                      placeholder="SIRET"
                                                      mask="11111111111111"
                                                      :class="{ 'is-invalid': $v.formData.siret.$error }"
                                                      @input="maskedDelayTouch($v.formData.siret)"
                                                      v-model="formData.siret"
                                        ></masked-input>
                                        <FormError error="Le numéro SIRET doit contenir 14 chiffres."
                                                   v-if="!$v.formData.siret.length && $v.formData.siret.$dirty"
                                        ></FormError>
                                        <FormError error="Le numéro SIRET est un champ obligatoire. Veuillez le renseigner."
                                                   v-if="!$v.formData.siret.required && $v.formData.siret.$dirty"
                                        ></FormError>
                                        <p v-if="this.legalInformation" class="input-legend">{{ legalInformation.siret.legalAdvice }}</p>
                                        <!-- SIRET -->
                                    </div>


                                    <!-- Code NAF -->
                                    <label class="required-field-asterisks required"
                                            for="code-naf"
                                    >Code NAF</label>
                                    <masked-input type="text"
                                                  id="code-naf"
                                                  class="form-control form-control-lg"
                                                  placeholder="Code NAF"
                                                  mask="*****"
                                                  :class="{ 'is-invalid': $v.formData.codeNaf.$error }"
                                                  @input="maskedDelayTouch($v.formData.codeNaf)"
                                                  v-model="formData.codeNaf"
                                    ></masked-input>
                                    <FormError error="Le code NAF doit conenir 5 symboles."
                                               v-if="!$v.formData.codeNaf.length && $v.formData.codeNaf.$dirty"
                                    ></FormError>
                                    <FormError error="Le code NAF est un champ obligatoire. Veuillez le renseigner."
                                               v-if="!$v.formData.codeNaf.required && $v.formData.codeNaf.$dirty"
                                    ></FormError>
                                    <div v-if="this.legalInformation">
                                        <p class="input-legend"
                                           v-for="(legalAdvice, index) in legalInformation.codeNaf.legalAdvice"
                                           :key="index"
                                        >{{ legalAdvice }}</p>
                                        <ul>
                                            <li v-for="(link, index) in legalInformation.codeNaf.links"
                                                :key="index"
                                            >
                                                <span class="input-legend">> Consulter</span>
                                                <a class="code-naf-link" target="_blank" :href="link">Voir un exemple</a>
                                            </li>
                                        </ul>
                                        <span class="invalid-feedback d-block">
                                            <span class="d-block">
                                                <span class="form-error-message ml-1">{{ legalInformation.codeNaf.attention }}</span>
                                            </span>
                                        </span>
                                    </div>
                                    <!-- Code NAF -->

                                    <!-- Convention -->
                                    <div class="form-group">
                                        <label
                                                class="required-field-asterisks"
                                                for="convention">Sélectionnez la convention collective applicable
                                        </label>
                                        <select id="convention"
                                                :disabled="$v.formData.codeNaf.$invalid"
                                                class="form-control select2"
                                                v-model="formData.collectiveAgreementId"
                                        >
                                            <option v-for="collectiveAgreement in preparedCollectiveAgreements"
                                                    :key="collectiveAgreement.id"
                                                    :value="collectiveAgreement.id"
                                            >{{ collectiveAgreement.codeIdcc }} - {{ collectiveAgreement.name }}
                                            </option>
                                            <!-- for specific ids (id = 54 has string idcc) -->
                                            <template v-if="preparedSpecificCollectiveAgreements.length">
                                                <option
                                                    v-for="collectiveAgreement in preparedSpecificCollectiveAgreements"
                                                    :key="collectiveAgreement.id"
                                                    :value="collectiveAgreement.id"
                                                >{{ collectiveAgreement.name }}</option>
                                            </template>

                                            <option :value="false">Ma convention n'est pas dans la liste</option>
                                        </select>
                                        <div v-if="this.legalInformation">
                                            <p v-for="(legalAdvice, index) in legalInformation.collectiveAgreement.legalAdvice"
                                               :key="index"
                                               class="input-legend mt-1"
                                               >{{ legalAdvice }}</p>
                                        </div>
                                    </div>
                                    <!-- Convention -->

                                    <!-- ccn 18 attention text -->
                                    <div class="mt-1" v-if="isCcn18NotFrame">
                                        <span class="invalid-feedback d-block">
                                            <span class="d-block">
                                                <span class="form-error-message ml-1 text-bold">
                                                    {{ legalInformation.ccn18NotFrameLegalAdviceText.legalAdvice }}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="mt-1" v-if="isCcn18Frame">
                                        <span class="invalid-feedback d-block">
                                            <span class="d-block">
                                                <span class="form-error-message ml-1 text-bold">
                                                    {{ legalInformation.ccn18FrameLegalAdviceText.legalAdvice }}
                                                </span>
                                            </span>
                                        </span>
                                    </div>
                                    <!-- ccn 18 attention text -->
                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-9 mx-sm-auto my-md-4">
                            <div class="mx-sm-auto">
                                <button class="btn btn-success btn-lg btn-link btn__return"
                                        :disabled="$v.$invalid || isLoading"
                                        @click.prevent="submit"
                                >
                                    <span>Confirmer et continuer</span>
                                    <span
                                            v-if="isLoading"
                                            class="spinner-border spinner-border-sm ml-2"
                                            role="status"
                                            aria-hidden="true"
                                    ></span>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ValidationDelayTouch from '../../../mixins/validationDelayTouch';
    import FormError from '../../../components/FormError';
    import MaskedInput from 'vue-masked-input';
    import DueFirstStepManager from '../../../service/manager/due/firstStepManager';
    import DueStepsNavigation from '../../../mixins/dueStepsNavigation';
    import Header from '../../../components/Header';
    import { maskedInputLength } from '../../../utils/validation';
    import { required } from 'vuelidate/lib/validators';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        mixins: [ValidationDelayTouch, DueStepsNavigation],
        props: ['id'],
        data() {
            return {
                formData: {
                    companyName: '',
                    isSiren: null,
                    siret: '',
                    siren: '',
                    codeNaf: '',
                    collectiveAgreementId: null
                },
                isLoading: false,
                // todo:: if new will be add create new logic
                specificIds: [54],
                collectiveAgreementIdForSpecificNotFrame: 55,
                collectiveAgreementIdForSpecificFrame: 56,
                // todo
            };
        },
        computed: {
            ...mapGetters({
                collectiveAgreements: 'collectiveAgreements',
                due: 'due',
                dueId: 'dueId',
                legalInformation: 'legalInformation'
            }),
            codeNaf() {
                return this.formData.codeNaf;
            },
            // for specific ids (id = 54 has string idcc)
            preparedCollectiveAgreements() {
                return this.collectiveAgreements.filter(
                    collectiveAgreement => !this.specificIds.includes(collectiveAgreement.id)
                );
            },
            preparedSpecificCollectiveAgreements() {
                return this.collectiveAgreements.filter(
                    collectiveAgreement => this.specificIds.includes(collectiveAgreement.id)
                );
            },
            isCcn18NotFrame() {
                return this.formData.collectiveAgreementId === this.collectiveAgreementIdForSpecificNotFrame;
            },
            isCcn18Frame() {
                return this.formData.collectiveAgreementId === this.collectiveAgreementIdForSpecificFrame;
            }
        },
        watch: {
            codeNaf(value) {
                this.fetchConventionsByCodeNaf(value);
            },
            id: function(newVal) {
                if (!newVal) {
                    this.clearFormData();
                    this.clearDueData();
                }
            }
        },
        async created() {
            await this.fetchDue();
            await this.redirectToCurrentStep();
            await this.fetchDueLegalInformation();
        },
        methods: {
            ...mapActions({
                fetchCollectiveAgreements: 'fetchCollectiveAgreements',
                redirectToCurrentStep: 'redirectToCurrentStep',
                createDue: 'createDue',
                fetchCurrentDue: 'fetchCurrentDue',
                setCurrentStep: 'setCurrentStep',
                fetchDueLegalInformation: 'fetchDueLegalInformation',
                clearDueData: 'clearDueData'
            }),
            async fetchDue() {
                if (this.$route.params.id) {
                    await this.fetchCurrentDue(this.$route.params.id);
                    this.formData = {
                      ...this.formData,
                      ...DueFirstStepManager.createFormDataForFirstStepFromResponse(this.due)
                    };
                    if (this.due.codeNaf) {
                      await this.fetchConventionsByCodeNaf(this.due.codeNaf);
                    }
                } else {
                    this.clearFormData();

                    if (this.due) {
                      this.formData.companyName = this.due.companyName || '';
                      this.formData.isSiren = this.due.siret ? false : (this.due.siren ? true : null);
                      this.formData.siren = this.due.siren || '';
                      this.formData.siret = this.due.siret || '';
                      this.formData.codeNaf = this.due.codeNaf || '';
                      this.formData.collectiveAgreementId = (this.due.collectiveAgreement || {}).id || null;
                    } else {
                      await this.clearDueData();
                    }
                }
            },
            async fetchConventionsByCodeNaf(codeNaf) {
                if (codeNaf.replace(/[( |_)]/g,'').length !== 5) {
                    return;
                }
                await this.fetchCollectiveAgreements(codeNaf);
            },
            async submit() {
                this.isLoading = true;
                await this.createDue(DueFirstStepManager.createDueRequest(this.formData));
                this.isLoading = false;

                if (false === this.formData.collectiveAgreementId) {
                    await this.$router.push({ name: 'due-no-ccn-contact-lawyers'});
                    return;
                }

                await this.$router.push(this.buildRoute('due-second-step'));
            },
            clearFormData() {
                this.formData.companyName = '';
                this.formData.isSiren = null;
                this.formData.siret = '';
                this.formData.siren = '';
                this.formData.codeNaf = '';
                this.formData.collectiveAgreementId = null
            }
        },
        validations() {
            let validations = {
                formData: {
                    companyName: {
                        required
                    },
                    isSiren: {
                        required
                    },
                    codeNaf: {
                        length: maskedInputLength(5),
                        required
                    },
                    collectiveAgreementId: {
                        required
                    }
                }
            };

            if (true === this.formData.isSiren) {
                validations.formData.siren = {
                    length: maskedInputLength(9),
                    required
                };
            }

            if (false === this.formData.isSiren) {
                validations.formData.siret = {
                    length: maskedInputLength(14),
                    required
                }
            }

            return validations;
        },
        components: {
            Header,
            Sidebar,
            Footer,
            FormError,
            MaskedInput
        }
    }
</script>

<style scoped lang="scss">
    .code-naf-link {
        margin-left: 3px;
        font-size: 0.9rem;
        color: $color-primary;
        text-decoration: underline;
    }
</style>
